/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type TruvuToursContainer_user = {
    readonly profile: {
        readonly name: string;
        readonly surname: string;
        readonly profileImageURL: string;
    } | null;
    readonly " $refType": "TruvuToursContainer_user";
};
export type TruvuToursContainer_user$data = TruvuToursContainer_user;
export type TruvuToursContainer_user$key = {
    readonly " $data"?: TruvuToursContainer_user$data;
    readonly " $fragmentRefs": FragmentRefs<"TruvuToursContainer_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TruvuToursContainer_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "surname",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "profileImageURL",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '1375ed36c5d14e4a463e2585e2921f84';
export default node;
